import styled from 'styled-components';

import { SPACING } from '~/common/constants/spacing';

export const MainLayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%;
  background-color: ${({ theme }) => theme.neutral950};
  overflow: auto;
  overflow-y: auto;
  scrollbar-width: thin;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 1150px;
  padding: ${SPACING._16};
  width: 100%;
  gap: ${SPACING._16};
  min-height: 0;
`;

export const StyBodyWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding-top: 60px;
  overflow-x: hidden;
  overflow-y: auto;
`;
